<template>
<div class="contents">
  <admin adminType="staff"/>
</div>
</template>
<script>
import Admin from './../Admin/AdminMemberList.vue'
export default {
  name: 'staff-members',
  components: {
    Admin
  }
}
</script>